import component from './not-saved-ch.vue'

export default component
